import styled from 'styled-components';

export const Wrapper = styled.div`
  background: #ffffff;  
`;

export const Container = styled.div`
  .banner{
    width:100%;display:block;
  }
  .list{
    display:flex;align-items:center;margin-top:.5rem;
    .item{
      flex: 1;height: .55rem;
      .child{
        height: .32rem;
        .text{
          display:flex;align-items:center;justify-content:center;height:100%;
          p{
            font-size: .32rem;font-weight: 300;color: #999999;
          }
          span{
            font-size: .24rem;font-weight: 300;color: #999999;margin: 0 0 0 .06rem;
          }
        }
      }
    }
    .item:nth-child(1){
      width: 1.8rem;flex: none;
    }
    .item.active{
      .child{
        .text{
          p{
            font-size: .32rem;font-weight: 500;color: #816AA6;
          }
          span{
            font-size: .24rem;font-weight: 500;color: #816AA6;
          }
        }
      }
      .child::after{
        content: '';width: 1.08rem;height: .06rem;background: #816AA6;border-radius: .06rem;display:block;margin: .18rem auto 0;
      }
    }
  }
  .title{
    height: .24rem;font-size: .24rem;font-weight: 300;color: #999999;line-height: .24rem;margin-top:.56rem;padding: 0 .3rem;
  }
  .times{
    padding: 0 .9rem 0 .3rem;display:flex;align-items:center;height: 1rem;height: 1.1rem;
    .label{
      font-size: .28rem;font-weight: 400;color: #999999;margin-right:.34rem;
    }
    .picker{
      height: .7rem;background: #FFFFFF;box-shadow: 0px .02rem .16rem .02rem rgba(81, 78, 107, 0.1);border-radius: .05rem;
      flex:1;display:flex;align-items:center;justify-content:center;
      >div{
        height:100%!important;min-height: 0!important;width:100%!important;
        .am-list-item,.am-list-item-middle{
          height:100%!important;min-height: 0!important;padding: 0;width:100%!important;
        }
        .am-list-extra{
          flex: 1!important;display:flex;align-items:center;justify-content:center;font-size: .28rem;font-weight: 400;color: #999999;
        }
      }
    }
  }
  .btns{
    margin-top:.6rem;padding: 0 .3rem;
    .btn{
      width: 100%;height: .9rem;border: 1px solid #816AA6;border-radius: .1rem;font-size: .32rem;font-weight: 400;color: #816AA6;line-height: .9rem;text-align:center;
    }
  }
`;